import { render } from "./Assistentes.vue?vue&type=template&id=120e4094&scoped=true"
import script from "./Assistentes.vue?vue&type=script&lang=js"
export * from "./Assistentes.vue?vue&type=script&lang=js"

import "./Assistentes.vue?vue&type=style&index=0&id=120e4094&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120e4094"]])

export default __exports__